export class SearchOperator {

    constructor(
        public id: number,
        public name: string,
        public label: string
    ){}
}
